module.exports = __webpack_public_path__ + "static/media/AOW.c3b5bf9a.jpg";